import { AxiosResponse } from 'axios';
import React from 'react';
import { Message } from 'semantic-ui-react';

interface IProps {
    error?: AxiosResponse,
    text?: string
}

const ErrorMessage: React.FC<IProps> = ({ error, text }) => {
    return (
        <Message error>
            <Message.Header>{error && error.statusText}</Message.Header>
            {error && error.data && typeof error.data.errors === 'object' && Object.keys(error.data.errors).length > 0 && (
                <Message.List>
                    {Object.values(error.data.errors).flat().map((err, i) => (
                        <Message.Item key={i}> { err} </Message.Item>
                    ))}
                </Message.List>
            )}
            {text && <Message.Content content={text} />}
            {error && error.data && typeof error.data.errors === 'string' && <Message.Content content={error.data.errors} />}
        </Message>
    )
}

export default ErrorMessage
